// extracted by mini-css-extract-plugin
export var container = "_ad-0";
export var containerTopRight = "_ad-1";